import React from 'react'
import * as ROUTER from 'constants/appRouting'
import { FEATURE_FLAGS_KEY } from 'constants/index'

import { ReactComponent as MenuIconProfile } from 'assets/img/menu/menuIconProfile.svg'
import { ReactComponent as MenuIconDashboard } from 'assets/img/menu/menuIconDashboard.svg'
import { ReactComponent as MenuIconPerson } from 'assets/img/menu/menuIconPerson.svg'
import { ReactComponent as MenuIconPoint } from 'assets/img/menu/menuIconPoint.svg'
import { ReactComponent as MenuIconPlanet } from 'assets/img/menu/menuIconPlanet.svg'
import { ReactComponent as MenuIconBell } from 'assets/img/menu/menuIconBell.svg'
import { ReactComponent as MenuIconPersons } from 'assets/img/menu/menuIconPersons.svg'
import { ReactComponent as MenuIconPoints } from 'assets/img/menu/menuIconPoints.svg'

import RoleHelper from './role'

const menuItems = [
  {
    path: ROUTER.PROFILE_PERSONAL_INFO,
    alt: 'personalInfo',
    name: 'personalInfo',
    icon: <MenuIconProfile />,
    level: RoleHelper.ROLE_USER_LEVEL,
    group: 'right side',
    mobileGroup: 1,
  },
  {
    path: ROUTER.PROFILE_NOTIFICATIONS,
    alt: 'notifications',
    name: 'notifications',
    icon: <MenuIconBell />,
    level: RoleHelper.ROLE_USER_LEVEL,
    group: 'right side',
    mobileGroup: 1,
  },
  {
    path: ROUTER.APPLICATION_LIST,
    alt: 'Application',
    name: 'application',
    icon: <MenuIconDashboard />,
    level: RoleHelper.ROLE_SUPERADMIN_LEVEL,
    group: 1,
    mobileGroup: 2,
  },
  {
    path: ROUTER.LICENSEE_LIST,
    alt: 'Licensees',
    name: 'licensees',
    icon: <MenuIconPlanet />,
    level: RoleHelper.ROLE_SUPERADMIN_LEVEL,
    group: 1,
    mobileGroup: 2,
  },
  {
    path: ROUTER.LICENSEE_APPLICATION_LIST,
    alt: 'LicenseeApplication',
    name: 'licensee_application',
    icon: <MenuIconDashboard />,
    level: RoleHelper.ROLE_SUPERADMIN_LEVEL,
    group: 1,
    mobileGroup: 2,
  },
  {
    path: ROUTER.SISENSE_LIST,
    alt: 'Sisense Dashboard',
    name: 'sisense',
    icon: <MenuIconDashboard />,
    level: RoleHelper.ROLE_SUPERADMIN_LEVEL,
    group: 1,
    mobileGroup: 2,
  },
  {
    path: ROUTER.SITE_LIST,
    alt: 'Sites',
    name: 'site_list',
    icon: <MenuIconDashboard />,
    level: RoleHelper.ROLE_USER_LEVEL,
    group: 2,
    mobileGroup: 2,
  },
  {
    path: ROUTER.SITE_GROUP_LIST,
    alt: 'Site Groups',
    name: 'site_group_list',
    icon: <MenuIconDashboard />,
    level: RoleHelper.ROLE_USER_LEVEL,
    group: 2,
    mobileGroup: 2,
  },
  {
    path: ROUTER.LOCUS_LIST,
    alt: 'Locuses',
    name: 'locus_list',
    icon: <MenuIconPoint />,
    level: RoleHelper.ROLE_USER_LEVEL,
    group: 3,
    mobileGroup: 2,
  },
  {
    path: ROUTER.LOCUS_GROUP_LIST,
    alt: 'Locus Groups',
    name: 'unit_group_list',
    icon: <MenuIconPoints />,
    level: RoleHelper.ROLE_ADMIN_LEVEL,
    group: 3,
    mobileGroup: 2,
  },
  {
    path: ROUTER.USER_LIST,
    alt: 'Users',
    name: 'user_list',
    icon: <MenuIconPerson />,
    level: RoleHelper.ROLE_ADMIN_LEVEL,
    group: 4,
    mobileGroup: 2,
  },
  {
    path: ROUTER.USER_GROUP_LIST,
    alt: 'User Groups',
    name: 'user_group_list',
    icon: <MenuIconPersons />,
    level: RoleHelper.ROLE_ADMIN_LEVEL,
    group: 4,
    mobileGroup: 2,
  },

  {
    path: ROUTER.JOBS_WORKFLOW_ADMIN,
    alt: 'jobs',
    name: 'jobs',
    icon: <MenuIconPoint />,
    level: RoleHelper.ROLE_SUPERADMIN_LEVEL,
    group: 5,
    mobileGroup: 2,
  },
  {
    path: ROUTER.AUDIT,
    alt: 'Audit',
    name: 'audit',
    icon: <MenuIconPoint />,
    level: RoleHelper.ROLE_SUPERADMIN_LEVEL,
    group: 5,
    mobileGroup: 2,
  },
  {
    path: ROUTER.TRANSLATIONS,
    alt: 'Translations',
    name: 'translations',
    icon: <MenuIconPoint />,
    level: RoleHelper.ROLE_SUPERADMIN_LEVEL,
    group: 5,
    mobileGroup: 3,
  },
  {
    path: '#',
    alt: 'Feedback',
    name: 'leaveFeedback',
    icon: <MenuIconPoint />,
    level: RoleHelper.ROLE_USER_LEVEL,
    group: 5,
    mobileGroup: 3,
  },
  {
    path: ROUTER.FEATURE_FLAGS,
    alt: 'Features',
    name: FEATURE_FLAGS_KEY,
    icon: <MenuIconPoint />,
    level: null,
    group: 5,
    mobileGroup: 3,
  },
]

export const getProfileMenu = (
  roleLevel,
  allowedToManageWorkflows,
  allowedToManageFeatureFlags,
) =>
  menuItems.filter(
    item =>
      (item.level && item.level <= roleLevel) ||
      (allowedToManageWorkflows && item.name === 'jobs') ||
      (allowedToManageFeatureFlags && item.name === FEATURE_FLAGS_KEY),
  )

export const getProfileMenuItem = path =>
  menuItems.find(item => path.includes(item.path))

export function getProfileItemRoleLevel(path) {
  const item = menuItems.find(item => item.path === path)

  return item ? item.level : null
}

export const getProfileMobileMenu = (
  roleLevel,
  mobileGroup,
  allowedToManageWorkflows,
  allowedToManageFeatureFlags,
) =>
  menuItems.filter(
    item =>
      item.mobileGroup === mobileGroup &&
      ((item.level && item.level <= roleLevel) ||
        (allowedToManageWorkflows && item.name === 'jobs') ||
        (allowedToManageFeatureFlags && item.name === FEATURE_FLAGS_KEY)),
  )
